import React from "react";

/**
 * School contact consent (Saved page). Two actions: decline or share.
 */
const SchoolContactConsentModal = ({ open, onConfirmShare, onSaveWithoutSharing }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex min-h-full items-center justify-center overflow-y-auto bg-black/40 p-4 lg:items-start lg:justify-center lg:pt-[10vh] lg:pb-8"
      role="dialog"
      aria-modal="true"
      aria-labelledby="school-contact-title"
    >
      <div className="w-full max-w-lg rounded-xl bg-white px-8 py-6 shadow-xl max-h-[90vh] overflow-y-auto">
        {/* Title, body, and opt-out share one column: same left edge and width */}
        <div className="w-full max-w-full">
          <h2
            id="school-contact-title"
            className="text-xl font-semibold text-gray-900 text-left"
          >
            Let programs know you&apos;re interested?
          </h2>
          <p className="mt-3 text-gray-600 leading-relaxed text-left">
            We can share your name and email with graduate programs connected to the
            professors you&apos;ve saved. They may contact you with updates, events, or
            application info.
          </p>
          <p className="mt-2.5 text-gray-600 text-left">
            You can opt out anytime.
          </p>
        </div>
        {/* Right edge aligns with text block above (same w-full column); no extra modal-side inset */}
        <div className="mt-2 max-[450px]:mt-4 flex w-full max-w-full flex-row flex-nowrap items-center justify-end gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onSaveWithoutSharing}
            className="inline-flex shrink-0 items-center justify-center bg-transparent px-2 py-2.5 text-base font-medium text-gray-500/70 hover:text-[#0196BF] hover:underline underline-offset-2"
          >
            Not now
          </button>
          <button
            type="button"
            onClick={onConfirmShare}
            className="inline-flex shrink-0 items-center justify-center rounded-full bg-[#0196BF] px-4 py-2.5 text-base font-medium text-white hover:bg-[#017BA3] sm:px-6"
          >
            Share my info
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchoolContactConsentModal;
